// extracted by mini-css-extract-plugin
export default {"get_totals_button":"WorkQTotals_get_totals_button__Sk-i1"};